// extracted by mini-css-extract-plugin
export default {"meatball":"favourite-edit-menu__meatball--V1fgZ"};